<template>
    <div class="top-reviews-page">

        <!-- Header -->
        <header class="tr-header">
        <button class="back-btn" @click="goBack" aria-label="Back">←</button>
        <div class="title-wrap">
            <h2 class="place">{{ placeName }}</h2>
            <div class="subtitle">5 Top Review</div>
        </div>
        <div class="spacer"></div>
        </header>

        <div class="tr-list">
            <article
                v-for="r in reviews"
                :key="r.id"
                class="tr-card"
                @click="openReview(r)"
            >
                <!-- Thumbnail no play button -->
                <div class="thumb">
                    <template v-if="r.thumb">
                        <img :src="r.thumb" alt="" />
                    </template>
                    <template v-else>
                        <div class="thumb--empty"></div>
                    </template>
                </div>


                <div class="content">
                <div class="rating-row">
                    <span class="star" aria-hidden="true">
                    <svg viewBox="0 0 24 24" class="star-svg">
                        <path d="M12 3.2l2.37 4.8 5.3.77-3.83 3.73.9 5.28L12 15.9l-4.74 2.48.9-5.28L4.3 8.77l5.33-.77L12 3.2z" fill="currentColor"/>
                    </svg>
                    </span>
                    <span class="rating-num">{{ r.rating }}</span>
                    <span class="rating-total">/5</span>
                </div>

                <p class="review-text">{{ r.text }}</p>

                <div class="meta">
                    <img :src="r.user.avatar" alt="" class="avatar" />
                    <div class="by">
                    <div class="name">– {{ r.user.name }}</div>
                    <div class="time">{{ r.time }}</div>
                    </div>
                </div>
                </div>
            </article>
        </div>


    </div>
</template>

<script>
export default {
    name: 'TopReviews',
    data() {
        return {
        placeName: this.$route.query.name || 'Rebung Chef Ismail',
        reviews: [
            {
            id: 1,
            rating: 5,
            text:
                'A true gem for traditional Malay cuisine! The buffet offers a wide selection and everything tastes homemade.',
            thumb: "",
            time: '2m ago',
            user: { name: 'Emily S', avatar: require('@/assets/img/defaultusercartoon.png') },
            },
            {
            id: 2,
            rating: 5,
            text:
                'The best place to experience kampung-style cooking in Kuala Lumpur. Cozy ambiance and friendly staff.',
            thumb: "",
            time: '1st January 2025',
            user: { name: 'Defran R Aditya', avatar: require('@/assets/img/defaultusercartoon.png') },
            },
            {
            id: 3,
            rating: 5,
            text:
                'Dining at Restoran Rebung Chef Ismail was a wonderful experience. The rendang is a must-try!',
            thumb: "",
            time: '2nd January 2025',
            user: { name: 'Lily M', avatar: require('@/assets/img/defaultusercartoon.png') },
            },
            {
            id: 4,
            rating: 5,
            text:
                "This restaurant serves some of the best Malay food I've had. The desserts were amazing too.",
            thumb: "",
            time: '3rd January 2025',
            user: { name: 'John D', avatar: require('@/assets/img/defaultusercartoon.png') },
            },
            {
            id: 5,
            rating: 5,
            text:
                'If you’re looking for a place that serves traditional Malay cuisine, look no further. Highly recommended.',
            thumb: "",
            time: '3rd January 2025',
            user: { name: 'Alex P', avatar: require('@/assets/img/defaultusercartoon.png') },
            },
        ],
        };
    },
    methods: {
        goBack() {
        this.$router.back();
        },
        openReview(item) {
        console.log('open', item);
        },
    },
};
</script>

<style scoped>
.top-reviews-page {
    background: #fff;
  min-height: 100vh;
  padding: 12px;
}

/* Header */
.tr-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 12px;
}
.back-btn {
  appearance: none;
  border: 0;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  padding: 6px;
  cursor: pointer;
}
.title-wrap {
  text-align: center;
}
.place {
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  color: #111;
}
.subtitle {
  color: #7c6ff3; /* purple */
  font-weight: 600;
  font-size: 13px;
  margin-top: 2px;
}
.spacer { width: 24px; }

/* List wrapper (white card like device body) */
.tr-list {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
}

/* Cards */
.tr-card {
  display: grid;
  grid-template-columns: 112px 1fr;
  gap: 12px;
  border: 1px solid #eee;
  border-radius: 16px;
  padding: 12px;
  margin-bottom: 14px;
  box-shadow: 0 1px 0 rgba(0,0,0,.02);
  cursor: pointer;
}

/* Thumbnail*/
.thumb {
  width: 112px;
  height: 84px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: #f3f3f3;
}
.thumb--empty {
  width: 100%;
  height: 100%;
  background: #F1F1F5;            /* light grey */
  border: 1px dashed #D8D8E0;     /* optional dashed frame */
  border-radius: 12px;
}
.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Content */
.rating-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
}
.star {
  color: #ff9800;
  display: inline-flex;
}
.star-svg {
  width: 16px;
  height: 16px;
}
.rating-num {
  font-weight: 700;
  color: #111;
}
.rating-total {
  color: #888;
  font-weight: 600;
}

.review-text {
  color: #222;
  margin: 6px 0 10px;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* clamp similar to screenshot */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.meta {
  display: flex;
  align-items: center;
  gap: 8px;
}
.avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
}
.by .name {
  font-weight: 700;
  color: #222;
  line-height: 1.1;
}
.by .time {
  font-size: 12px;
  color: #8b8b8b;
}
</style>
